module.exports = __webpack_public_path__ + "static/media/nike-eor-watch-where-we-are-going.af9ab3a6.mp4";